const getSeoCategoryImageUrl = (path: string) => {
  if (!path) {
    return "";
  }

  let resolvedPath = path;
  if (!resolvedPath.startsWith("/")) {
    resolvedPath = `/${resolvedPath}`;
  }

  return resolvedPath.startsWith("/images")
    ? resolvedPath
    : `https://cdnimg.webstaurantstore.com${resolvedPath}`;
};

export default getSeoCategoryImageUrl;
